export default {
  imprint: "Legal notice",
  "imprint.represented-by": "Represented by the managing directors:",
  "imprint.registration-commercial-register":
    "Entry in the Commercial Register:",

  "imprint.contact": "Contact",
  "imprint.contact-form": "Contact form:",
  "imprint.contact-form.click": "Click here",
  "imprint.general": "General:",
  "imprint.jobs": "Jobs:",
  "imprint.responsibility":
    "Person responsible within the meaning of § 55 para. 2 RStV for journalistic and editorial content: Avelios Medical GmbH (address as above).",
  "imprint.note":
    "Note according to the ODR Regulation: The European Commission provides a platform for online dispute resolution, which you can find at https://ec.europa.eu/consumers/odr. However, we are not willing or obliged to participate in the online dispute resolution.",
};
